import { render, staticRenderFns } from "./show.vue?vue&type=template&id=11c83621&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=11c83621&prod&lang=scss&scoped=true"
import style1 from "./show.vue?vue&type=style&index=1&id=11c83621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c83621",
  null
  
)

export default component.exports